import * as Types from '../gql/types2';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {"context":{"clientName":"graphql2"}} as const;
export type RenameProductMutationVariables = Types.Exact<{
  input: Types.RenameProductCommand;
}>;


export type RenameProductMutation = { __typename?: 'MutationModel', products: { __typename?: 'ProductMutationModel', renameProduct: { __typename?: 'ValidationResponse', errors: Array<{ __typename?: 'ValidationError', message: string, argumentName?: string | null }> } } };


export const RenameProductDocument = gql`
    mutation RenameProduct($input: RenameProductCommand!) {
  products {
    renameProduct(input: $input) {
      errors {
        message
        argumentName
      }
    }
  }
}
    `;
export type RenameProductMutationFn = Apollo.MutationFunction<RenameProductMutation, RenameProductMutationVariables>;

/**
 * __useRenameProductMutation__
 *
 * To run a mutation, you first call `useRenameProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameProductMutation, { data, loading, error }] = useRenameProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRenameProductMutation(baseOptions?: Apollo.MutationHookOptions<RenameProductMutation, RenameProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameProductMutation, RenameProductMutationVariables>(RenameProductDocument, options);
      }
export type RenameProductMutationHookResult = ReturnType<typeof useRenameProductMutation>;
export type RenameProductMutationResult = Apollo.MutationResult<RenameProductMutation>;
export type RenameProductMutationOptions = Apollo.BaseMutationOptions<RenameProductMutation, RenameProductMutationVariables>;